import { render, staticRenderFns } from "./avatar_creator.vue?vue&type=template&id=8f2f5bdc&scoped=true&"
import script from "./avatar_creator.vue?vue&type=script&lang=js&"
export * from "./avatar_creator.vue?vue&type=script&lang=js&"
import style0 from "./avatar_creator.vue?vue&type=style&index=0&id=8f2f5bdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2f5bdc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PopupIntroAvatar: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/popup_intro_avatar.vue').default,PopupTalkSchedule: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/popup_talk_schedule.vue').default})
